import type { InvoicePaymentEntry } from '@/store/slices/wallet';

/**
 * The invoice details modal's "Payment" row value. Just the payment date: the
 * invoice's own status badge (Paid / Pending / …) already conveys the outcome, so
 * repeating a raw, unmapped API status word here (e.g. "Success") read as redundant
 * next to it. Returns `undefined` when there's no date to show (the row is then
 * omitted entirely).
 */
export const paymentRowValue = (
  payment: InvoicePaymentEntry | undefined,
  formatDateFull: (ts: number) => string,
): string | undefined => {
  if (!payment?.date) return undefined;
  return formatDateFull(Date.parse(payment.date) || 0);
};
